export const REACT_APP_STATIC_ASSETS =
  "https://cdn-mediastoresopi.azureedge.net/static-assets-dev/";
